import { createFileRoute, Link, Outlet } from "@tanstack/solid-router";
import { backendService } from "../../backend/backend.service";
import { ValidationError } from "../../backend/models/errors/Validation.error";
import { withLoaderErrorHandling } from "../../utils/with-loader-error-handling";

export const Route = createFileRoute("/history/$formId")({
  loader: ({ params, context }) =>
    withLoaderErrorHandling(async () => {
      const formId = Number(params.formId);

      if (!Number.isInteger(formId)) {
        throw new ValidationError(
          "Parameter is not valid",
          "FORM",
          "formId",
          params.formId
        );
      }

      const form = await backendService.getForm(formId);

      const categories = await backendService.getCategories(form.templateId);

      return { formId, form, categories };
    }, "/history"),
  component: RouteComponent,
  notFoundComponent: () => {
    return (
      <div>
        <p>This is the notFoundComponent configured on root route</p>
        <Link to="/">Start Over</Link>
      </div>
    );
  },
});

function RouteComponent() {
  return <Outlet />;
}
